import { RunSchema } from '@/types/schema';

// sometimes we use fake runs to represent an error state or other data like a run that is not yet started
export function isRealRun(run: RunSchema | undefined): boolean {
  return run?.status != null;
}
